import React from "react";

const Ssubject = ({ text, onClick }) => {
  const isRtl = /[؀-ۿ]/.test(text);
  return (
    <td
      dir={isRtl ? "rtl" : undefined}
      className="matiere"
      onClick={onClick}
      style={{
        fontWeight: "bold",
        fontSize: 14,
        textAlign: isRtl ? "right" : "center",
        color: "#1f2937",
        boxSizing: "border-box",
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        padding: "6px 10px",
        cursor: "pointer",
      }}
    >
      {text}
    </td>
  );
};

export default Ssubject;
